<div
  class="main-container flex flex-column overflow-hidden radius-md"
  [ngClass]="severityClass"
>
  <div
    class="flex align-items-center gap-spacing-lg flex-1 pt-spacing-none pb-spacing-none pr-spacing-md pl-spacing-xl overflow-hidden"
  >
    <span
      class="title-box body-medium-regular flex-1 webkit-box-one-line label-large-medium"
      [title]="text"
      >{{ text }}</span
    >
    <div class="value-box p-spacing-default radius-sm flex align-items-center">
      <span
        class="body-large-medium text-overflow-ellipsis label-large-semibold"
        [title]="value"
        >{{ value }}</span
      >
    </div>
  </div>
  <div class="under-line"></div>
</div>
